export const StopDescriptionActions = {
    SET_IS_STOP_DESCRIPTION_OPEN: 'StopDescription.SET_IS_STOP_DESCRIPTION_OPEN',
    SET_SUPPLEMENTAL_MEDIA_TYPE: 'StopDescription.SET_SUPPLEMENTAL_MEDIA_TYPE',
}
